import { createBrowserHistory } from 'history';
import { App } from './pages/landingPage';
import { page } from './models/track';
import React from 'react';
import {
    SanityContext,
    sanityController,
    SanitySnapshot,
} from './lib/landingPage';
import './index.less';
import { Router } from 'react-router-dom';

declare global {
    interface Window {
        snapSaveState: unknown;
        __SANITY_PRELOADED_STATE__?: SanitySnapshot;
    }
}

const LpRoot = () => {
    const history = createBrowserHistory();

    const getSanityStore = () => {
        if (
            typeof window !== 'undefined' &&
            window.__SANITY_PRELOADED_STATE__
        ) {
            const sanityStore = sanityController(
                window.__SANITY_PRELOADED_STATE__
            );
            // Allow property to be garbage collected
            delete window.__SANITY_PRELOADED_STATE__;
            return sanityStore;
        }
        return sanityController();
    };

    if (typeof window !== 'undefined') {
        window.addEventListener('load', () => {
            page();
            history.listen(() => page());
        });
    }

    const sanityStore = getSanityStore();

    return (
        <React.StrictMode>
            <Router history={history}>
                <SanityContext.Provider value={sanityStore}>
                    <App />
                </SanityContext.Provider>
            </Router>
        </React.StrictMode>
    );
};

export default LpRoot;
